<script>
import DatePicker from '../DatePicker/DatePicker.vue';
import {mapActions, mapState} from 'vuex';
import store from '../../store';

export default {
    components: {
        DatePicker
    },
    computed: {
        ...mapState({
            season: state => state.stats.season,
            bookingPeriod: state => state.stats.bookingPeriod,
            arrivalPeriod: state => state.stats.arrivalPeriod
        })
    },
    watch: {
        bookingPeriod: () => {
            const supplierId = store.state.auth.supplier.id;
            store.dispatch('stats/getPeriodRevenue', supplierId);
        },
        arrivalPeriod: () => {
            const supplierId = store.state.auth.supplier.id;
            store.dispatch('stats/getPeriodRevenue', supplierId);
        }
    },
    methods: {
        ...mapActions({
            updateBookingPeriod: 'stats/updateBookingPeriod',
            updateArrivalPeriod: 'stats/updateArrivalPeriod',
            getPeriodRevenue: 'stats/getPeriodRevenue'

        })
    },
}
</script>

<template>
    <div class="stat-filters">
        <div class="stat-filters__option">
            <date-picker :value="bookingPeriod"
                         :label="$t('statFilters.datepickers.booking.label')"
                         :heading="$t('statFilters.datepickers.booking.heading')"
                         @input="updateBookingPeriod($event)"/>
        </div>
        <div class="stat-filters__option">
            <date-picker :value="arrivalPeriod"
                         :label="$t('statFilters.datepickers.arrival.label')"
                         :heading="$t('statFilters.datepickers.arrival.heading')"
                         @input="updateArrivalPeriod($event)"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StatFilters/StatFilters.vue